<template>
  <div class="accordion">
    <div
      class="accordion__header"
      @click="toggleAccordion"
    >
      <h5 class="accordion__title">
        <slot name="title" />
      </h5>
      <span
        v-if="iconType === 'plus'"
        class="accordion__icon"
        :class="{ 'is-open': isOpen }"
      >
      </span>
      <OpenDownIcon
        v-else
        :class="clsx('accordion__icon-arrow', { 'is-open': isOpen })"
        :color="iconColor"
      />
    </div>
    <div
      ref="accordionBody"
      class="accordion__body"
      :class="{ 'is-open': isOpen }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import { OpenDownIcon } from '@/shared/ui/icons';

export default {
  components: { OpenDownIcon },
  props: {
    initialOpen: {
      type: Boolean,
      default: false,
    },
    iconType: {
      type: String,
      default: 'plus',
      validator: (value) => ['plus', 'arrow'].includes(value),
    },
    iconColor: {
      type: String,
      default: '#6171E4',
    },
  },
  data() {
    return {
      isOpen: this.initialOpen
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
      this.$emit('toggleAccordion', this.isOpen);
    },
    clsx,
  }
};
</script>

<style lang="scss" scoped>
.accordion {
  background-color: #EBF2FF;
  border-radius: 32px;
  overflow: hidden;
  margin-bottom: 8px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #EBF2FF;
    padding: 24px;
    transition: background-color 0.3s ease;
    cursor: pointer;
    user-select: none;
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: #313437;
    margin: 0;

    @media (max-width: 720px) {
      padding-right: 20px;
    }

    @media (max-width: 600px) {
      font-size: 18px;
    }
  }

  &__icon {
    position: relative;
    width: 20px;
    height: 20px;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #6171E4;
      transition: transform 0.3s ease;
    }

    &::before {
      width: 20px;
      height: 2px;
    }

    &::after {
      width: 2px;
      height: 20px;
    }

    &.is-open {
      &::after {
        transform: translate(-50%, -50%) rotate(90deg);
      }
    }
  }

  &__icon-arrow {
    width: 25px;
    height: 25px;
    transition: transform 0.2s;

    &.is-open {
      transform: rotate(180deg);
    }
  }

  &__body {
    font-family: 'Geist', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #494E53;
    background-color: #EBF2FF;
    padding: 0 24px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out, padding 0.3s ease-out;

    &.is-open {
      max-height: fit-content;
      padding: 24px;
    }
  }
}
</style>
